import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../_models/daws/trip';

@Pipe({ name: 'fullAddressFilter' })
export class FullAddressFilterPipe implements PipeTransform {
  transform(address: Address, returnHtml: boolean): string {
    returnHtml = returnHtml || false;
    let addrStr = '';
    if (address.City !== '' && address.City !== null) {
      addrStr += `${address.City}, `;
    }
    if (address.State !== '' && address.State !== null) {
      addrStr += `${address.State} `;
    }
    if (address.Zip !== '' && address.Zip !== null) {
      addrStr += `${address.Zip} `;
    }

    if (returnHtml) {
      if (address.StreetAddress !== '' && address.StreetAddress !== null) {
        addrStr = `<strong>${address.StreetAddress}</strong>, ${addrStr}`;
      }
      if (address.SPLC !== '' && address.SPLC !== null) {
        addrStr = `<strong>${address.SPLC}'</strong>, ${addrStr}`;
      }
    } else {
      if (address.StreetAddress !== '' && address.StreetAddress !== null) {
        addrStr = `${address.StreetAddress}, ${addrStr}`;
      }
      if (address.SPLC !== '' && address.SPLC !== null) {
        addrStr = `${address.SPLC}, ${addrStr}`;
      }
    }
    return addrStr;
  }
}
